import { Location } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const FleetPolicyPage = lazy(() => import('../pages/FleetPolicyPage'));
const TriggerEventsPage = lazy(() => import('../pages/TriggerEventsPage'));
const TriggersPage = lazy(() => import('../pages/TriggersPage'));
const TriggerPage = lazy(() => import('../pages/TriggerPage'));
const TriggersLandingPage = lazy(() => import('../pages/TriggersLandingPage'));
const CreateAlertFormPage = lazy(() => import('../pages/CreateAlertFormPage'));

const routes = [
  {
    path: Location.ALERTS,
    component: FleetPolicyPage,
    exact: true,
  },
  {
    path: Location.ALERTS_TYPE,
    component: TriggerEventsPage,
    exact: true,
  },
  {
    path: Location.ALERTS_TRIGGERS,
    component: TriggersPage,
    exact: true,
  },
  {
    path: Location.ALERTS_TRIGGERS_CREATE,
    component: TriggerPage,
    exact: true,
  },
  {
    path: Location.ALERTS_TRIGGERS_EDIT,
    component: TriggerPage,
    exact: true,
  },
  {
    path: Location.ALERTS_LP,
    component: TriggersLandingPage,
    exact: true,
  },
  {
    path: Location.ALERTS_BLUEPRINT_CREATE,
    component: CreateAlertFormPage,
    exact: true,
  },
  {
    path: Location.ALERTS_BLUEPRINT_EDIT,
    component: CreateAlertFormPage,
    exact: true,
  },
];

export default routes;
